export enum Privilege {
    USER_MANAGEMENT,
    LIST_ALL_PROJECT,
    VIEW_PROJECT_MANAGEMENT,
    EDIT_PROJECT_CONFIGURATION,
    DELETE_PROJECT_CONFIGURATION,
    EDIT_DIMENSION,
    DELETE_DIMENSION,
    EDIT_TAXONOMY,
    DELETE_TAXONOMY,
    EDIT_PROMPTTYPE,
    DELETE_PROMPTTYPE,
    EDIT_CATEGORY_SCORE,
    DELETE_CATEGORY_SCORE,
    EDIT_GUIDED_PROMPT_QUESTION,
    DELETE_GUIDED_PROMPT_QUESTION,
    EDIT_ALL_PROMPTS,
    DELETE_ALL_PROMPTS,
    EDIT_ALL_VALIDATION_RULES,
    DELETE_ALL_VALIDATION_RULES,
    USER_ACCESS_OVERVIEW,
    PUBLISH_PROMPT,
    MANAGE_AGENT,
}